export default "__VITE_ASSET__bDx$OwAm__"